"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieAuthApi = exports.loginApi = exports.signupApi = void 0;
const apiPath_1 = require("../apiPath");
const signupApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.signUp.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.signupApi = signupApi;
const loginApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.login.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.loginApi = loginApi;
const cookieAuthApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.auth.authByCookie.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.cookieAuthApi = cookieAuthApi;
// export const optVerificationApi = async (
//   axiosInstance: AxiosInstance,
//   form: OTPConfirmation
// ): Promise<LoginResponse> => {
//   try {
//     const _data = await axiosInstance.post<LoginResponse>(
//       API_PATH.auth.optConfirmation.frontend,
//       form
//     );
//     return _data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
//  };
// export const optRequestApi = async (
//   axiosInstance: AxiosInstance,
//   { mobileNumber }: { mobileNumber?: string }
// ) => {
//   try {
//     const _data = await axiosInstance.post<OptResponseDta>(
//       API_PATH.auth.optRequest.frontend,
//       {
//         mobileNumber,
//       }
//     );
//     return _data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
//  };
//# sourceMappingURL=auth.js.map